import firebase from 'firebase/app';

const db = () => firebase.database().ref('vipService');

export const VipService = {
  fetch: () => {
    return db()
      .once('value')
      .then(res => {
        return Object.values(res.val() || {}).sort(
          (a, b) => b.createDt - a.createDt
        );
      });
  }
};
